import { useState, useEffect } from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CheckCircle } from '../../icons/check-circle-solid.svg';
import { ReactComponent as XmarkCircle } from '../../icons/xmark-circle.svg';

const RULES = [
  { key: 'ruleLength', test: (v) => v.length >= 8 },
  { key: 'ruleUppercase', test: (v) => /[A-Z]/.test(v) },
  { key: 'ruleNumber', test: (v) => /[0-9]/.test(v) },
  { key: 'ruleSpecial', test: (v) => /[^a-zA-Z0-9]/.test(v) },
];

const PasswordRequirements = ({ password, show }) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(show);
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    if (show) {
      setVisible(true);
      setExiting(false);
    } else if (visible) {
      setExiting(true);

      const timer = setTimeout(() => {
        setVisible(false);
        setExiting(false);
      }, 250);

      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- runs on a change of show only
  }, [show]);

  if (!visible) return null;

  return (
    <ul className={cx('mg-password-requirements', { exiting })}>
      {RULES.map(({ key, test }) => {
        const met = test(password || '');
        return (
          <li key={key} className={cx('req-item', { met })}>
            <span className="req-icon">{met ? <CheckCircle /> : <XmarkCircle />}</span>
            {t(`auth.${key}`)}
          </li>
        );
      })}
    </ul>
  );
};

export default PasswordRequirements;
